import * as api from "@/apiv2/uiInteractions";
import * as companyActions from "@/components/new/CompanyUiInteractions/company-ui-interactions.actions";
import * as userActions from "@/components/new/UserUiInteractions/user-ui-interactions.actions";

// Reads both UI-interaction maps in one request and drops each one into the
// slice that owns it. The backend returns { company, user }, where either side
// is null when nothing has been saved yet, so an empty map is the fallback.
//
// This endpoint skips the usual camelCase conversion, so the keys inside each
// map keep the exact snake_case spelling they have in the database. The body
// still arrives parsed: the request asks for JSON, so XHR parses it before axios
// sees it, and hands back null if the body was not valid JSON.
//
// Log rather than toast on failure: remembered preferences are a background
// nicety, and the user still gets working defaults for this session.
export const fetchAllUiInteractions = () => async (dispatch) => {
  try {
    const { data } = await api.getAllUiInteractions()();
    dispatch(companyActions.setInteractions(data?.company ?? {}));
    dispatch(userActions.setInteractions(data?.user ?? {}));
  } catch (error) {
    console.error("UI interactions request failed", error);
  }
};
